import { render, staticRenderFns } from "./TeethStates.vue?vue&type=template&id=3489a634&"
import script from "./TeethStates.vue?vue&type=script&lang=js&"
export * from "./TeethStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports